import React, { useState } from "react";
import InputField from "../InputField";
import SubmitButton from "../SubmitButton";

export default function SetInitialPasswordForm({ onSubmit }) {

  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");

    if (newPassword.length < 8) {
      setError("رمز عبور باید حداقل ۸ کاراکتر باشد.");
      return;
    }

    if (newPassword !== newPasswordConfirm) {
      setError("رمز عبور و تکرار آن یکسان نیست.");
      return;
    }

    await onSubmit({ newPassword, newPasswordConfirm });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">

      <InputField
        label="رمز عبور جدید"
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />

      <InputField
        label="تکرار رمز عبور"
        type="password"
        value={newPasswordConfirm}
        onChange={(e) => setNewPasswordConfirm(e.target.value)}
      />

      {error && <p className="text-red-600 text-sm">{error}</p>}

      <SubmitButton text="ثبت رمز عبور" />

    </form>
  );
}
